var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M15.63 2.52c-.48 0-.95.19-1.31.55l-6.2 6.17-.13.13-.04.2-.43 2.19-.2.92.92-.2 2.19-.43.2-.04.13-.13 6.17-6.2a1.86 1.86 0 0 0-1.3-3.16m0 1.21q.22 0 .42.22.42.42 0 .85L10 10.86l-1.07.21.21-1.07 6.06-6.05q.2-.22.43-.22M2.5 5v12.5H15V9.26l-1.25 1.25v5.74h-10v-10h5.74L10.74 5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default ForwardRef;